import React from 'react';
import Slider, { SliderProps } from '@wix/da-shared-react/pkg/Slider';
import { PapiGallection } from '@wix/da-types-papi';
import FolderCard from '../FolderCard';
import withFeatureFlags, {
  WithFeatureFlagsProps,
} from '@wix/da-shared-react/pkg/redux/flags/withFeatureFlags';
import {
  withMobileContext,
  WithMobileContextProps,
} from '@wix/da-shared-react/dist/src/Context';
import { BiDataHook } from '@wix/da-shared-react/pkg/biLogger';

import * as s from './FolderSlider.scss';

export type Props = Pick<SliderProps, 'scrollToIndex'> & {
  folders: PapiGallection[];
  selectedFolderId: number | null;
};

export const FolderSlider: React.FC<
  Props & WithFeatureFlagsProps & WithMobileContextProps
> = ({ folders, selectedFolderId, flags, isMobile }) => {
  const isSelectedFolder = ({ folderId }) => folderId === selectedFolderId;
  return (
    <Slider
      className={s['folders-slider']}
      scrollToIndex={folders.findIndex(isSelectedFolder)}
      smoothInitialScroll={false}
      dataHook={BiDataHook.PROFILE_GALLECTION_FOLDER}
    >
      {folders
        .filter(folder => !folder.parentId)
        .map((folder, index) => (
          <FolderCard
            width={parseInt(
              isMobile
                ? s['folder-card-width-mobile']
                : s['folder-card-width-desktop']
            )}
            className={s['folder-card']}
            key={folder.folderId}
            folder={folder}
            indexInsideParent={index}
            dataHook={BiDataHook.PROFILE_GALLECTION_FOLDER_ITEM + index}
            withCommentsCount={true}
          />
        ))}
    </Slider>
  );
};
FolderSlider.displayName = 'FolderSlider';

export default withFeatureFlags(withMobileContext(FolderSlider));
